import {App} from './app';
import 'firebase/auth';

export const Auth = App.auth();



// WEBPACK FOOTER //
// ./src/firebase/auth.js